import React, { useState } from 'react';
import { CustomMode } from './types';
import ModeFormFields from './ModeFormFields';

interface EditableModeProps {
    mode: CustomMode;
    modeName: string;
    modeKey: string;
    isNameDuplicate: (name: string, excludeName?: string) => boolean;
    onSave: (oldModeKey: string, newModeName: string, updatedMode: CustomMode) => void;
    onCancel: () => void;
}

const EditableMode: React.FC<EditableModeProps> = ({
    mode,
    modeName,
    modeKey,
    isNameDuplicate,
    onSave,
    onCancel
}) => {
    const [editData, setEditData] = useState({
        name: modeName,
        description: mode.description,
        instructions: mode.instructions,
        preferredModel: mode.preferredModel || ''
    });

    const handleSave = () => {
        if (editData.name.trim() === '' || editData.instructions.trim() === '') return;

        if (isNameDuplicate(editData.name, modeName)) {
            alert('A mode with this name already exists. Please choose a different name.');
            return;
        }

        onSave(modeKey, editData.name, {
            description: editData.description.trim(),
            instructions: editData.instructions.trim(),
            preferredModel: editData.preferredModel
        });
    };

    const isSaveDisabled = !editData.name.trim() || !editData.instructions.trim() || isNameDuplicate(editData.name, modeName);

    return (
        <div className="bg-neutral-200 dark:bg-neutral-700 p-3 rounded-lg">
            <ModeFormFields
                name={editData.name}
                description={editData.description}
                instructions={editData.instructions}
                preferredModel={editData.preferredModel}
                onNameChange={(name) => setEditData({ ...editData, name })}
                onDescriptionChange={(description) => setEditData({ ...editData, description })}
                onInstructionsChange={(instructions) => setEditData({ ...editData, instructions })}
                onPreferredModelChange={(preferredModel) => setEditData({ ...editData, preferredModel })}
            />
            <div className="flex space-x-2">
                <button
                    onClick={handleSave}
                    disabled={isSaveDisabled}
                    className="bg-cyan-600 hover:bg-cyan-700 text-white px-3 py-1 rounded text-sm disabled:bg-neutral-400 disabled:cursor-not-allowed"
                >
                    Save
                </button>
                <button
                    onClick={onCancel}
                    className="bg-neutral-500 hover:bg-neutral-600 text-white px-3 py-1 rounded text-sm"
                >
                    Cancel
                </button>
            </div>
        </div>
    );
};

export default EditableMode;